export const PHASE_LABELS = {
  accepted: "Driver Accepted",
  en_route_pickup: "Driver En Route",
  arrived: "Driver Has Arrived",
  on_trip: "On Trip",
  waiting: "Driver Waiting",
  completed: "Completed",
};

export const phaseOf = (ride) =>
  ride?.trip_phase || (ride?.status === "in_progress" ? "en_route_pickup" : ride?.status);

export const phaseLabel = (ride) => PHASE_LABELS[phaseOf(ride)] || "Tracking";

export const etaTargetLabel = (ride) =>
  ["on_trip", "waiting"].includes(phaseOf(ride)) ? "to dropoff" : "to pickup";

// Live wait seconds/charge mirroring backend trip_tracking.wait_summary
export const liveWait = (ride, now = Date.now()) => {
  const segments = ride?.wait_segments || [];
  const seconds = segments.reduce((sum, s) => {
    const end = s.end ? new Date(s.end).getTime() : now;
    return sum + Math.max(0, (end - new Date(s.start).getTime()) / 1000);
  }, 0);
  const minutes = Math.floor(seconds / 60);
  const free = ride?.wait_free_minutes ?? 5;
  const rate = ride?.wait_rate_per_minute ?? 0.5;
  const isPrivate = ride?.ride_type === "private";
  const charge = isPrivate ? Math.max(0, minutes - free) * rate : 0;
  const base = ride?.fare_estimate || 0;
  return {
    seconds,
    minutes,
    free,
    rate,
    charge,
    isPrivate,
    running: segments.some((s) => !s.end),
    freeLeft: Math.max(0, free * 60 - seconds),
    total: base + charge,
  };
};

export const fmtClock = (secs) => {
  const s = Math.floor(secs);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};
